import { FC } from 'react';

import { useRoute } from '@core/navigation';
import {
  RoutePath,
  AnalyticsCategory,
  AnalyticsEvent,
} from '@common/constants';
import { TrackPageView, useAnalytics } from '@wearehelpful/ui-stats';
import { useTranslation } from '@wearehelpful/ui-localization';
import { Page, Content, Header, Typography, Form } from '@wearehelpful/ui-kit';
import { Footer, Toolbar } from '@core/ui';
import { useBootstrapData } from '@bootstrap/hooks';

import { CareplanIndexForm } from './Index.types';
import { ItemTitle } from './Index.style';

export const Index: FC = () => {
  const [{ search }, { push }] = useRoute();
  const { t } = useTranslation();
  const { track } = useAnalytics();
  const { experiences } = useBootstrapData();

  const handleOnSubmit = ({ slug }: CareplanIndexForm) => {
    const item = experiences.find(({ slug: v }) => slug === v);

    const position = experiences.findIndex(({ slug: v }) => slug === v) + 1;

    track({
      id: AnalyticsEvent.CAREPLAN_EXPERIENCE_SELECTED,
      properties: {
        slug,
        title: item?.title,
        position,
      },
    });

    push({
      search,
      path: RoutePath.CAREPLAN_SELECT,
      params: { slug },
    });
  };

  return (
    <TrackPageView
      category={AnalyticsCategory.CAREPLAN}
      name={AnalyticsCategory.EXPERIENCE_SELECTION}
    >
      <Page>
        <Form<CareplanIndexForm> onSubmit={handleOnSubmit}>
          <Header>
            <Header.Back defaultHref={RoutePath.ROOT_HOME} />
          </Header>
          <Content>
            <Content.Subheader divider gap="md">
              <Typography variant="h2">
                {t('subheadings.careplan.title')}
              </Typography>
              <Typography variant="p1">
                {t('subheadings.careplan.description')}
              </Typography>
            </Content.Subheader>
            <Content.Fixed>
              <Form.RadioGroup name="slug" validation={{ required: true }}>
                {experiences.map(({ id, image, title, slug }) => {
                  return (
                    <Form.RadioGroup.Item key={id} value={slug}>
                      {image && (
                        <img alt={title} width={68} height={40} src={image} />
                      )}
                      <ItemTitle variant="p2">{title}</ItemTitle>
                    </Form.RadioGroup.Item>
                  );
                })}
              </Form.RadioGroup>
            </Content.Fixed>
          </Content>
          <Footer>
            <Toolbar padding>
              <Form.Submit checkValidity>{t('actions.next')}</Form.Submit>
            </Toolbar>
          </Footer>
        </Form>
      </Page>
    </TrackPageView>
  );
};
